import { IconButton } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

export default function CopyIconInput({ value, size, messageValue }: CopyIconInputProps) {
    return (
        <IconButton
            size={size}
            sx={{
                padding: '2px',
                marginLeft: '4px',
                '& .MuiSvgIcon-root': {
                    fontSize: '14px'
                }
            }}
            onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(value ?? '');
                enqueueSnackbar(`${messageValue} copiado para área de transferência!`, { variant: 'success' });
            }}
        >
            <ContentCopyOutlinedIcon />
        </IconButton>
    )
}

interface CopyIconInputProps {
    value: string;
    messageValue: string;
    size: 'small' | 'medium' | 'large';
}